import { ProgressSpinner } from 'primereact/progressspinner';
import React, { FC } from 'react';

type AppLoadingProps = {
  isLoading: boolean;
  children: React.ReactNode;
};

const AppLoading: FC<AppLoadingProps> = ({ isLoading, children }) => {
  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          paddingTop: '2.5rem',
          paddingBottom: '2.5rem',
        }}
      >
        <ProgressSpinner />
      </div>
    );
  }

  return <>{children}</>;
};

export default AppLoading;
